export default "__VITE_ASSET__D2g9m2jH__"